module.exports = __webpack_public_path__ + "static/media/star.5be6bfde.svg";